import Icon from "elements/Icon";
import useWebsiteBuilder, { getWebsiteBuilderContentInfo } from "Hooks/useWebsiteBuilder";
import Colors from "modules/Colors";
import Sty from "modules/Sty";
import { CSSProperties } from "react";

interface WebsiteBuilderHeaderProps {
    contentIndex: number;
    rightSideContent?: React.ReactNode;
    isDivider?: boolean;
}

const WebsiteBuilderHeader = ({
    contentIndex,
    rightSideContent,
    isDivider = false,
}: WebsiteBuilderHeaderProps) => {
    const {
        websiteContent,
        setWebsiteContent,
    } = useWebsiteBuilder();

    const renderDefaultIcons = () => {
        return (
            <>
                {/* <Icon
                    className="websiteBuilderHeaderIcon"
                    icon="chevronUp"
                    color={contentIndex === 0 ? Colors.greyDark : Colors.purple}
                    onClick={() => {
                        if (contentIndex === 0) return;
                        const newContent = [...websiteContent];
                        [newContent[contentIndex - 1], newContent[contentIndex]] =
                            [newContent[contentIndex], newContent[contentIndex - 1]];
                        setWebsiteContent(newContent);
                    }}
                />
                <Icon
                    className="websiteBuilderHeaderIcon"
                    icon="chevronDown"
                    color={contentIndex === websiteContent.length - 1 ? Colors.greyDark : Colors.purple}
                    onClick={() => {
                        if (contentIndex === websiteContent.length - 1) return;
                        const newContent = [...websiteContent];
                        [newContent[contentIndex], newContent[contentIndex + 1]] =
                            [newContent[contentIndex + 1], newContent[contentIndex]];
                        setWebsiteContent(newContent);
                    }}
                /> */}

                <Icon
                    className="websiteBuilderRemoveContentIcon"
                    icon="trash"
                    color={Colors.greyDark}
                    onClick={() => {
                        setWebsiteContent(websiteContent.filter((_, i) => i !== contentIndex));
                    }}
                />
            </>
        )
    }

    return (
        <>
            <div
                className="websiteBuilderHeader"
                style={sty.websiteBuilderHeader}
            >
                {/* <Icon
                className="websiteBuilderDragHandleIcon"
                icon="drag"
                color={Colors.grey}
                style={{
                    marginLeft: -16,
                    marginRight: 8,
                }}
            /> */}
                <div
                    className="websiteBuilderHeaderTitle"
                    style={sty.websiteBuilderHeaderTitle}
                >
                    {getWebsiteBuilderContentInfo(websiteContent[contentIndex].type).title}
                </div>

                {isDivider &&
                    <div
                        style={{
                            display: 'flex',
                            height: 1,
                            width: '100%',
                            backgroundColor: Colors.grey,
                            marginLeft: 16,
                            marginRight: 16,
                        }}
                    />
                }
                <div
                    className="websiteBuilderHeaderIcons"
                    style={sty.websiteBuilderHeaderIcons}
                >
                    {rightSideContent}
                    {renderDefaultIcons()}
                </div>
            </div>
        </>
    )
}

const sty: Record<string, CSSProperties> = {
    websiteBuilderHeader: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        flexWrap: 'wrap',
    },
    websiteBuilderHeaderIcons: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginLeft: 'auto',
        flexWrap: 'wrap',
    }
}

export default WebsiteBuilderHeader;